var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 168,
    viewBox: "0 0 256 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.653 21H106.386C101.451 21 97.4499 24.9838 97.4499 29.8981V37.541H97.3025C97.1354 37.541 97 37.6759 97 37.8422V42.193C97 42.3594 97.1354 42.4942 97.3025 42.4942H97.4499V46.7782H97.3026C97.135 46.7782 97 46.9123 97 47.0792V55.7027C97 55.8696 97.135 56.004 97.3026 56.004H97.4499V58.3802H97.3026C97.135 58.3802 97 58.5143 97 58.6812V67.3047C97 67.4716 97.135 67.606 97.3026 67.606H97.4499V138.102C97.4499 143.016 101.451 147 106.386 147H150.653C155.589 147 159.59 143.016 159.59 138.102V64.3856H159.697C159.865 64.3856 160 64.2512 160 64.0843V50.0967C160 49.9298 159.865 49.7957 159.697 49.7957H159.59V29.8981C159.59 24.9838 155.589 21 150.653 21Z",
    fill: "#7A00DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.674 29.8629C100.674 26.7233 103.213 24.1958 106.366 24.1958H111.934H144.888H150.456C153.609 24.1958 156.147 26.7233 156.147 29.8629V138.214C156.147 141.354 153.609 143.881 150.456 143.881H106.366C103.213 143.881 100.674 141.354 100.674 138.214V29.8629Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.674 29.8629C100.674 26.7233 103.213 24.1958 106.366 24.1958H111.934H144.888H150.456C153.609 24.1958 156.147 26.7233 156.147 29.8629V138.214C156.147 141.354 153.609 143.881 150.456 143.881H106.366C103.213 143.881 100.674 141.354 100.674 138.214V29.8629Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 33,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 39,
    width: 31,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 55,
    width: 31,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 67,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 61,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 83,
    width: 31,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 111,
    width: 31,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 95,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 123,
    width: 23,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 89,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 117,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#FF8833"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhone);
export default __webpack_public_path__ + "static/media/iPhone.6ff493b6018b5adfe45707e6ec3c4519.svg";
export { ForwardRef as ReactComponent };